// import React from 'react';
import Navbar from '../components/Navbar.js'
import React, { useEffect, useState, useRef } from 'react';
import DatePicker from "react-datepicker";
import { GoogleMap, LoadScript, Marker, useJsApiLoader } from '@react-google-maps/api';
import config from '../JSON/regions.json';
import states from '../JSON/us-state-boundaries.json'
import { getMonth, getYear } from 'date-fns';
import range from "lodash/range";
import { json } from 'react-router';


const libraries = ['drawing'];
const mid = 'eb5e1352a8e4c7f2';



const Statistics = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_API_KEY,
    libraries: ['drawing'],
  });

  const [map, setMap] = useState(null);
  const [width, setWidth] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [height, setHeight] = useState(0);
  const [markers, setMarkers] = useState([]);
  const [jsonFiles, setJsonFiles] = useState([]);
  const date = new Date();
  const UTCEndDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

  const years = range(2025, getYear(new Date()) + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];


  useEffect(() => {
    setWidth(Math.max(document.documentElement.clientWidth - 400, 550));
    setHeight(Math.max(document.documentElement.clientHeight - 170, 400));
  }, []);

  const handleOnLoad = map => {
    setMap(map);
  };

  useEffect(() => {
    if (map) {
      var paths = []
      for (let i = 0; i < states.length; i++) {
        var coords = states[i]['st_asgeojson']['geometry']['coordinates']
        for (let j = 0; j < coords.length; j++) {
          var path = coords[j]
          if (path.length === 1) {
            path = path[0]
          }
          var latLngPath = []
          for (let k = 0; k < path.length; k++) {
            latLngPath.push(new window.google.maps.LatLng(path[k][1], path[k][0]))
          }
          paths.push(latLngPath)
        }
      }

      var polygons = new window.google.maps.Polygon({
        paths: paths,
        clickable: false,
        geodesic: false,
        // strokeColor: '#5A5A5A',
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 0.4,
        fillOpacity: 0,
        map: map
      });
    }
    scrapeJSONFiles()

  }, [map])

  
  async function scrapeJSONFiles() {
    try {
      const response = await fetch('https://sfr.umd.edu/felix/ip_json/');
      const html = await response.text();
      
      const jsonFiles = [...html.matchAll(/href="([^"]*\d{8}[^"]*\.json)"/g)]
      .map(m => m[1]);

      setJsonFiles(jsonFiles)
      
        

      console.log("Found JSON files:", jsonFiles);
      return jsonFiles;

    } catch (err) {
      console.error("Error fetching JSON links:", err);
    }
  }

  function getJSONfromDate(date) {
    const d = new Date(date);

    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    const formatted = `${year}${month}${day}`;
    const url = `https://sfr.umd.edu/felix/ip_json/ip_json_${formatted}.json`;
    return url;
  }


  useEffect(() => {
    async function loadMarkers() {
      try {
        const response = await fetch(getJSONfromDate(new Date(selectedDate)));
        if (!response.ok) {
          throw new Error('Error: ${response.status}');
        }
        const json = await response.json();
        setMarkers(json)
      } catch (err) {
        console.error("Failed to load markers:", err);
      }
    }

    loadMarkers();
  }, [selectedDate]);

  if (!isLoaded || !window.google) return <div>Loading map...</div>;

  return (
    <div style={{ backgroundColor: 'rgb(218, 227, 243)' }}>
      <Navbar />
      <div style={{ display: 'flex', height: height + 'px' }}>
        {/* <div style={{ width: '400px', padding: '20px', fontSize: '22px', textAlign: 'center' }}>
          <div style={{ marginBottom: '20px' }}>Total Unique Visits: <span style={{ fontWeight: 'bold', fontSize: '24px', }}>{markers.length}</span></div>


          <DatePicker
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
              decreaseYear,
              increaseYear,
              prevYearButtonDisabled,
              nextYearButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button onClick={decreaseYear} disabled={prevYearButtonDisabled}>
                  {"<<"}
                </button>
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                  {"<"}
                </button>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>


                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                  {">"}
                </button>
                <button onClick={increaseYear} disabled={nextYearButtonDisabled}>
                  {">>"}
                </button>
              </div>
            )}
            selected={selectedDate}
            onChange={(date) => {
              const onlyDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
              setSelectedDate(onlyDate);
            }}
            selectsStart
            minDate={new Date("2025-03-24")}
            maxDate={UTCEndDate}
            dateFormat="MM/dd/yyyy"
            className="centered-datepicker"

          />




        </div> */}
        <div style={{ width: '400px', padding: '20px', fontSize: '22px', textAlign: 'center' }}>
  <div style={{ marginBottom: '20px' }}>
    Total Unique Visits: <span style={{ fontWeight: 'bold', fontSize: '24px' }}>{markers.length}</span>
  </div>

  {/* Dropdown for available dates */}
  <select
    style={{ fontSize: '18px', padding: '6px', width: '100%' }}
    value={selectedDate ? selectedDate.toISOString().slice(0,10) : ""}
    onChange={(e) => {
      const dateStr = e.target.value; // format yyyy-mm-dd
      const [year, month, day] = dateStr.split("-");
      const newDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      setSelectedDate(newDate);
    }}
  >
    <option value="">Select a date</option>
    {[...jsonFiles].reverse().map((file, i) => {
  // Extract YYYYMMDD
  const match = file.match(/(\d{8})/);
  if (!match) return null;
  const yyyymmdd = match[1];
  const year = yyyymmdd.slice(0, 4);
  const month = yyyymmdd.slice(4, 6);
  const day = yyyymmdd.slice(6, 8);

  const formattedDate = `${year}-${month}-${day}`;

  return (
    <option key={i} value={formattedDate}>
      {`${month}/${day}/${year}`}
    </option>
  );
})}
  </select>
</div>
        <div style={{ flexGrow: 1 }}>
          <GoogleMap
            mapContainerStyle={{
              width: '100%',
              height: '100%'
            }}
            center={config['conus']['center']}
            zoom={config['conus']['zoom']}
            options={{
              mapId: mid,
              isFractionalZoomEnabled: true,
              streetViewControl: false,
            }}
            onLoad={map => handleOnLoad(map)}
          >
            {markers.map((pos, i) => (
              <Marker
                key={i}
                position={pos}
                icon={{
                  path: window.google.maps.SymbolPath.CIRCLE,
                  fillColor: 'red',
                  fillOpacity: 1,
                  strokeWeight: 1,
                  scale: 6,
                }}
              />
            ))}
          </GoogleMap>
        </div>
      </div>
    </div>
  );

}
export default Statistics;
